/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyContactTypeModel } from '../models/client-survey-contact-type-model';
import { getSurveyContactTypes$Json } from '../fn/survey-contact-type/get-survey-contact-types-json';
import { GetSurveyContactTypes$Json$Params } from '../fn/survey-contact-type/get-survey-contact-types-json';
import { getSurveyContactTypes$Plain } from '../fn/survey-contact-type/get-survey-contact-types-plain';
import { GetSurveyContactTypes$Plain$Params } from '../fn/survey-contact-type/get-survey-contact-types-plain';

@Injectable({ providedIn: 'root' })
export class SurveyContactTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyContactTypes()` */
  static readonly GetSurveyContactTypesPath = '/api/SurveyContactType';

  /**
   * get all surveycontacttype.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactTypes$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactTypes$Plain$Response(params?: GetSurveyContactTypes$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyContactTypeModel>>> {
    return getSurveyContactTypes$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveycontacttype.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactTypes$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactTypes$Plain(params?: GetSurveyContactTypes$Plain$Params, context?: HttpContext): Observable<Array<ClientSurveyContactTypeModel>> {
    return this.getSurveyContactTypes$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyContactTypeModel>>): Array<ClientSurveyContactTypeModel> => r.body)
    );
  }

  /**
   * get all surveycontacttype.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactTypes$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactTypes$Json$Response(params?: GetSurveyContactTypes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyContactTypeModel>>> {
    return getSurveyContactTypes$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveycontacttype.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactTypes$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactTypes$Json(params?: GetSurveyContactTypes$Json$Params, context?: HttpContext): Observable<Array<ClientSurveyContactTypeModel>> {
    return this.getSurveyContactTypes$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyContactTypeModel>>): Array<ClientSurveyContactTypeModel> => r.body)
    );
  }

}
